"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityEnum = void 0;
exports.instanceOfIdentityEnum = instanceOfIdentityEnum;
exports.IdentityEnumFromJSON = IdentityEnumFromJSON;
exports.IdentityEnumFromJSONTyped = IdentityEnumFromJSONTyped;
exports.IdentityEnumToJSON = IdentityEnumToJSON;
exports.IdentityEnumToJSONTyped = IdentityEnumToJSONTyped;
/**
 * * `C` - C
 * * `W` - W
 * * `U` - U
 * * `B` - B
 * * `R` - R
 * * `G` - G
 * * `WU` - WU
 * * `WB` - WB
 * * `RW` - RW
 * * `GW` - GW
 * * `UB` - UB
 * * `UR` - UR
 * * `GU` - GU
 * * `BR` - BR
 * * `BG` - BG
 * * `RG` - RG
 * * `WUB` - WUB
 * * `URW` - URW
 * * `GWU` - GWU
 * * `RWB` - RWB
 * * `WBG` - WBG
 * * `RGW` - RGW
 * * `UBR` - UBR
 * * `BGU` - BGU
 * * `GUR` - GUR
 * * `BRG` - BRG
 * * `WUBR` - WUBR
 * * `UBRG` - UBRG
 * * `BRGW` - BRGW
 * * `RGWU` - RGWU
 * * `GWUB` - GWUB
 * * `WUBRG` - WUBRG
 * @export
 * @enum {string}
 */
var IdentityEnum;
(function (IdentityEnum) {
    IdentityEnum["C"] = "C";
    IdentityEnum["W"] = "W";
    IdentityEnum["U"] = "U";
    IdentityEnum["B"] = "B";
    IdentityEnum["R"] = "R";
    IdentityEnum["G"] = "G";
    IdentityEnum["Wu"] = "WU";
    IdentityEnum["Wb"] = "WB";
    IdentityEnum["Rw"] = "RW";
    IdentityEnum["Gw"] = "GW";
    IdentityEnum["Ub"] = "UB";
    IdentityEnum["Ur"] = "UR";
    IdentityEnum["Gu"] = "GU";
    IdentityEnum["Br"] = "BR";
    IdentityEnum["Bg"] = "BG";
    IdentityEnum["Rg"] = "RG";
    IdentityEnum["Wub"] = "WUB";
    IdentityEnum["Urw"] = "URW";
    IdentityEnum["Gwu"] = "GWU";
    IdentityEnum["Rwb"] = "RWB";
    IdentityEnum["Wbg"] = "WBG";
    IdentityEnum["Rgw"] = "RGW";
    IdentityEnum["Ubr"] = "UBR";
    IdentityEnum["Bgu"] = "BGU";
    IdentityEnum["Gur"] = "GUR";
    IdentityEnum["Brg"] = "BRG";
    IdentityEnum["Wubr"] = "WUBR";
    IdentityEnum["Ubrg"] = "UBRG";
    IdentityEnum["Brgw"] = "BRGW";
    IdentityEnum["Rgwu"] = "RGWU";
    IdentityEnum["Gwub"] = "GWUB";
    IdentityEnum["Wubrg"] = "WUBRG";
})(IdentityEnum || (exports.IdentityEnum = IdentityEnum = {}));
function instanceOfIdentityEnum(value) {
    for (const key in IdentityEnum) {
        if (Object.prototype.hasOwnProperty.call(IdentityEnum, key)) {
            if (IdentityEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function IdentityEnumFromJSON(json) {
    return IdentityEnumFromJSONTyped(json, false);
}
function IdentityEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function IdentityEnumToJSON(value) {
    return value;
}
function IdentityEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=identityEnum.js.map